export default "__VITE_ASSET__DUNKzgad__"